import $ from 'jquery/src/jquery';

export default () => {
    const nodeSelectors = {
        opener: '[js-accordions="opener"]',
        hiddenContent: '[js-accordions="hidden-content"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.opener)) {
            return
        }

        initAccordions()
    }

    function initAccordions() {
        $(nodeSelectors.opener).on('click', function () {
            $(this).toggleClass('active')
            let hiddenContent = $(this).parent().find(nodeSelectors.hiddenContent)
            hiddenContent.slideToggle()
        })
    }

    return Object.freeze({
        init,
    })
}